export const products = {
    state: {
        status: 'idle',
        products: null,
        productsForFilters: null,
        dictProducts: null,
        dictProductsPagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        dictProductsStatus: 'idle',
        recentlySelected: []
    },
    mutations: {
        SET_PRODUCTS_STATUS(state, status) {
            state.status = status
        },
        SET_PRODUCTS(state, products) {
            state.products = products
        },
        SET_PRODUCTS_FOR_FILTERS(state, products) {
            state.productsForFilters = products
        },
        SET_DICTPRODUCTS(state, payload) {
            state.dictProducts = payload
        },
        SET_DICTPRODUCTS_PAGINATION(state, payload) {
            state.dictProductsPagination = payload
        },
        SET_DICTPRODUCTS_STATUS(state, payload) {
            state.dictProductsStatus = payload
        },
        SET_RECENTLY_SELECTED_PRODUCTS(state, payload) {
            state.recentlySelected = payload
        }
    },
    actions: {
        productsFetchForFilters({ state, commit, getters }, payload) {
            commit('SET_PRODUCTS_STATUS', 'loading')
            return this.$api
                .get('dict_products', {
                    params: {
                        page: payload && payload.page ? payload.page : null,
                        per: 10,
                        includes: 'dict_product',
                        sort: 'name',
                        direction: 'asc',
                        name: payload && payload.query
                    }
                })
                .then(response => {
                    const products = response.data.data
                    if (payload && payload.page && payload.page !== 1) {
                        const newProducts = [...state.productsForFilters]
                        commit('SET_PRODUCTS_FOR_FILTERS', [
                            ...newProducts,
                            ...products
                        ])
                    } else {
                        commit('SET_PRODUCTS_FOR_FILTERS', products)
                    }
                    commit('SET_PRODUCTS_STATUS', 'idle')
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_PRODUCTS_STATUS', 'idle')
                    }
                })
        },
        async dictProductsFetch({ state, commit }, payload) {
            try {
                commit('SET_DICTPRODUCTS_STATUS', 'loading')
                const params = {
                    ...payload.params,
                    per: payload?.per || state.dictProductsPagination.perPage,
                    page: payload?.page || state.dictProductsPagination.page
                }
                const res = await this.$api.get('dict_products', {
                    params
                })
                if (res.data) {
                    commit('SET_DICTPRODUCTS', res.data.data)
                    commit(
                        'SET_DICTPRODUCTS_PAGINATION',
                        res.data.pagination[0]
                    )
                    commit('SET_DICTPRODUCTS_STATUS', 'idle')
                    return res.data.data
                }
            } catch (error) {
                commit('SET_DICTPRODUCTS_STATUS', 'idle')
                throw Error(error)
            }
        },
        async clearDictProducts({ commit }) {
            commit('SET_DICTPRODUCTS', null)
            const initState = await this.$storage.getItem('initialState')
            commit(
                'SET_DICTPRODUCTS_PAGINATION',
                initState.products.dictProductsPagination
            )
        },
        setRecentlySelectedProducts({ commit }, payload) {
            commit('SET_RECENTLY_SELECTED_PRODUCTS', payload)
        },
        setMainPropsToSubproducts({ getters }, payload) {
            const selectedGroups = payload.areLabels
                ? getters.getSelectedLabelGroups
                : getters.getSelectedPromoGroups

            const searchedGroup = selectedGroups.find(
                el => el.id === payload.promotion.groupId
            )
            const searchedPromo = searchedGroup?.promos.find(
                el => el.id === payload.promotion.id
            )
            if (!searchedPromo) return

            if (searchedPromo.subscriptionsEqualPrices.equalPrices) {
                const priceGroup =
                    searchedPromo.subscriptionsEqualPrices.priceGroups[
                        payload.priceGroupIdx || 0
                    ]
                const groupShops = priceGroup.filter(el => el.checked)
                groupShops.forEach(shop => {
                    const mainProducts = shop.products.filter(prod => prod.main)
                    mainProducts.forEach(mainProd => {
                        shop.products.forEach(prod => {
                            if (
                                prod.promoDictProductId ===
                                mainProd.promoDictProductId
                            ) {
                                prod.productPrice = mainProd.productPrice
                                prod.print_copies = mainProd.print_copies
                            }
                        })
                    })
                })
            } else {
                searchedPromo.subscriptions.forEach(shop => {
                    const mainProducts = shop.products.filter(prod => prod.main)
                    mainProducts.forEach(mainProd => {
                        shop.products.forEach(prod => {
                            if (
                                prod.promoDictProductId ===
                                mainProd.promoDictProductId
                            ) {
                                prod.productPrice = mainProd.productPrice
                                prod.print_copies = mainProd.print_copies
                            }
                        })
                    })
                })
            }
        },
        setDictProducts({ commit }, payload) {
            commit('SET_DICTPRODUCTS', payload)
        },
        setDictProductsPagination({ commit }, payload) {
            commit('SET_DICTPRODUCTS_PAGINATION', payload)
        },

        async fetchProducts({ commit, getters }, { params, config } = {}) {
            try {
                return await this.$api('products', { params, config })
            } catch (err) {
                console.log(err)
            }
        },

        async fetchProductSets({ commit, getters }, { params, config }) {
            try {
                return await this.$api('product_sets', {
                    params,
                    config
                })
            } catch (err) {
                console.log(err)
            }
        }
    },
    getters: {
        getProducts: state => {
            if (state.products) {
                return state.products
            }
        },
        getDictProducts: state => state.dictProducts,
        getDictProductsStatus: state => state.dictProductsStatus,
        getDictProductsPagination: state => state.dictProductsPagination,
        getProductsStatus: state => {
            return state.status
        },
        getProductsForFilters: state => {
            if (state.productsForFilters) {
                const products = []
                state.productsForFilters.map(prod => {
                    const index = products.findIndex(x => x.value === prod.id)
                    if (index === -1) {
                        products.push({
                            value: prod.id,
                            label: prod.name
                        })
                    }
                })
                return products
            }
        },
        getProductNamesForFilters: state => {
            if (state.productsForFilters) {
                const products = []
                state.productsForFilters.map(prod => {
                    const index = products.findIndex(x => x.value === prod.id)
                    if (index === -1) {
                        products.push({
                            value: prod.name,
                            label: prod.name
                        })
                    }
                })
                return products
            }
        },
        getRecentlySelectedProducts: state => state.recentlySelected
    }
}
